<form class="form" [formGroup]="contactForm" (ngSubmit)="save()">
    <form-group title="{{ 'SERVICE_PROVIDERS.CREATE.CONTACT_PERSON.PERSON' | translate }}" isLast="true">
      <field-holder>
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.NAME'| translate}}
          </mat-label>
          <input matInput type="text" maxlength="54" formControlName="name" autocomplete="off" required />
          <mat-error *ngIf="contactForm.get('name').hasError('required')">
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.NAME_ERROR' | translate }}
          </mat-error>    
        </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.KINSHIP'| translate}}
            </mat-label>
            <mat-select formControlName="kinship" [compareWith]="compareRelationshipObjects" required>
              <mat-option *ngFor="let relationship of relationshipOptions" [value]="relationship">
                {{ relationship.title }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="contactForm.get('kinship').hasError('required')">
              {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.KINSHIP_ERROR' | translate }}
            </mat-error>    
        </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.ADDRESS'| translate}}
          </mat-label>
          <input matInput type="text" maxlength="67" formControlName="address" autocomplete="off" required />
          <mat-error *ngIf="contactForm.get('address').hasError('required')">
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.ADDRESS_ERROR' | translate }}
          </mat-error>    
        </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.PHONE'| translate}}
          </mat-label>
          <input matInput type="text" maxlength="31" formControlName="phone" autocomplete="off" />
          <mat-error *ngIf="contactForm.get('phone').hasError('required')">
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.PHONE_ERROR' | translate }}
          </mat-error>    
        </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.EMAIL'| translate}}
          </mat-label>
          <input matInput type="email" formControlName="email" autocomplete="off" />
          <mat-error *ngIf="contactForm.get('email').hasError('required')">
            {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_02.CONTACT_PERSON.EMAIL_ERROR' | translate }}
          </mat-error>    
        </mat-form-field>
      </field-holder>
    </form-group>
  
    <form-footer>
      <button mat-stroked-button color="primary" type="button" (click)="closeDialog()"
        class="form-footer__button form-footer__button--secondary">
        {{ 'GLOBAL.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit" class="form-footer__button form-footer__button--primary"
        [disabled]="contactForm.invalid">
        {{ 'GLOBAL.SAVE' | translate }}
      </button>
    </form-footer>
</form>